import ApiService from '@/services/api.service'

class CustomerError extends Error {
  constructor(errorCode, message, errorFields) {
    super(message)
    this.name = this.constructor.name
    this.errorCode = errorCode
    this.message = message
    this.fields = errorFields
  }
}

const CustomerService = {
  getCustomers: async function(filter) {
    try {
      const response = await ApiService.get('/api/customer', filter)
      return response.data
    } catch (e) {
      throw new CustomerError(e.response.status, e.response.data.error)
    }
  },

  createCustomer: async function(customer) {
    try {
      const response = await ApiService.post(`/api/customer/`, customer)
      return response.data
    } catch (e) {
      throw new CustomerError(e.response.status, e.response.data.error)
    }
  },

  updateCustomer: async function(customer) {
    try {
      const response = await ApiService.put(
        `/api/customer/${customer.id}`,
        customer
      )
      return response.data
    } catch (e) {
      console.log(e)
      throw new CustomerError(
        e.response.status,
        e.response.data.error,
        e.response.data.errors
      )
    }
  },

  deleteCustomer: async function(id) {
    try {
      const response = await ApiService.delete(`/api/customer/${id}`)
      return response.data
    } catch (e) {
      throw new CustomerError(e.response.status, e.response.data.error)
    }
  }
}

export default CustomerService

export { CustomerService, CustomerError }
